import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import TopSelectSlownik from "../../../../../componentsTopsa/selects/TopSelectSlownik";
import AppConfig from "../../../../../AppConfig";
import moment from 'moment'
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";
import {TopAlertInformacja} from "../../../../../componentsTopsa/alerty/TopAlerts";
import Validator from "../../../../../utilities/Validator";

export default class LinieForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            validatorMessages: [],
            typdefaultTyp: null,
            linia: {
                "dataWaznosci": new Date().toJSON().substr(0, 10),
                "idLi": null,
                "numer": '',
                "przedzialKm": "",
                "przedzialKmMies": "",
                "relacja": "",
                "trasaGlownaId": 0,
                "trasaPowrotnaId": 0,
                "typ": "ZWYKLA",
                "wydawca": "",
                "zezwolenie": ""
            },
            data: moment(),
            trasa:null,
            trasaPowrotna:null,
        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.ustawSlownikTypIEdycje = this.ustawSlownikTypIEdycje.bind(this)
        this.onChangeTrasaSelect = this.onChangeTrasaSelect.bind(this)
        this.onChangeTrasaPowrotnaSelect = this.onChangeTrasaPowrotnaSelect.bind(this)
        this.onChangeData = this.onChangeData.bind(this)
        this.onChangeTyp = this.onChangeTyp.bind(this)
        this.onChangeInput = this.onChangeInput.bind(this)
    }

    componentDidMount() {
        this.ustawSlownikTypIEdycje(this.props)
    }

    componentWillReceiveProps(nextprops) {
        this.ustawSlownikTypIEdycje(nextprops)
    }

    ustawSlownikTypIEdycje(props) {
        if (props.typy.length > 0) {
            if (Boolean(props.edytowana)) {
                this.setState({
                    defaultTyp: props.edytowana.typ,
                    linia: props.edytowana,
                    data: moment(props.edytowana.dataWaznosci),
                    trasa: this.props.trasy.find(t => t.idTr === props.edytowana.trasaGlownaId),
                    trasaPowrotna: this.props.trasy.find(t => t.idTr === props.edytowana.trasaPowrotnaId)
                })

                for (let i = 0; i < Object.keys(props.edytowana).length; i++) {
                    let key = Object.keys(props.edytowana)[i]
                    if (Boolean(document.getElementById(key + 'Input')))
                        document.getElementById(key + 'Input').value = props.edytowana[key]
                }

            } else {
                if (!Boolean(this.state.defaultTyp))
                    this.setState({defaultTyp: 'ZWYKLA'})
            }
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    zmienWartoscWObiekcie(key, value) {
        let obj = this.state.linia
        obj[key] = value
        this.setState({linia: obj})
    }

    onChangeTrasaSelect(e) {
        this.setState({
            trasa: e
        })
        this.zmienWartoscWObiekcie('trasaGlownaId', e.idTr)

        if(e!==null){
            let powrotna = this.props.trasy.find(t=>t.idTrPow === e.idTr)
            if(Boolean(powrotna)){
                this.setState({
                    trasaPowrotna: powrotna
                })
                this.zmienWartoscWObiekcie('trasaPowrotnaId', powrotna.idTr)
            }
        }
    }

    onChangeTrasaPowrotnaSelect(e) {
        this.setState({
            trasaPowrotna: e
        })
        this.zmienWartoscWObiekcie('trasaPowrotnaId', e.idTr)
    }

    onChangeData(e) {
        this.setState({data: e})
        this.zmienWartoscWObiekcie('dataWaznosci', DateAndTimeFormat.formatYYYYMMDD(e))
    }

    onChangeTyp(e) {
        this.zmienWartoscWObiekcie('typ', e.wartosc)
        this.setState({defaultTyp: e.wartosc})
    }

    onChangeInput(e, key) {

        if(key === 'przedzialKm' || key === 'relacja' || key==='wydawca' || key === 'przedzialKmMies'){
            if(Validator.validateLenghtWithClearing(e.target.value, 100, key+'Input', this.state.linia[key])){
                this.zmienWartoscWObiekcie(key, e.target.value)
            }
        }else if(key==='zezwolenie'){
            if(Validator.validateLenghtWithClearing(e.target.value, 30, key+'Input', this.state.linia[key])){
                this.zmienWartoscWObiekcie(key, e.target.value)
            }
        }else{
            this.zmienWartoscWObiekcie(key, e.target.value)
        }
    }

    onClickZapisz() {

        this.setState({validatorMessages: []})

        let poprawne = true;
        this.state.validatorMessages = [];

        if (this.state.linia.numer.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Numer nie jest uzupełniony')
        }
        else{
            if(!Validator.validateInt(this.state.linia.numer)){
                poprawne = false;
                this.dodajDoValidatorMessages('Numer musi być liczbą całkowitą')
            }
        }
        if (this.state.linia.przedzialKm.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Przedział (jednorazowe) nie jest uzupełniony')
        }else{

            if(!(/^[0-9]+(,[0-9]+)*$/.test(this.state.linia.przedzialKm))){
                poprawne = false;
                this.dodajDoValidatorMessages('W pole przedział należy podać cyfry całkowite oddzielone tylko przecinkiem, bez spacji. Kolejne cyfry powinny być większe od poprzedniej')
            }
        }
        if (this.state.linia.przedzialKmMies.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Przedział (miesięczne) nie jest uzupełniony')
        }else{

            if(!(/^[0-9]+(,[0-9]+)*$/.test(this.state.linia.przedzialKmMies))){
                poprawne = false;
                this.dodajDoValidatorMessages('W pole przedział należy podać cyfry całkowite oddzielone tylko przecinkiem, bez spacji. Kolejne cyfry powinny być większe od poprzedniej')
            }
        }
        if (this.state.linia.relacja.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Relacja nie jest uzupełniona')
        }
        if (this.state.linia.wydawca.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Wydawca nie jest uzupełniony')
        }
        if (this.state.linia.zezwolenie.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Zezwolenie nie jest uzupełnione')
        }

        if (!Boolean(this.state.linia.typ)) {
            poprawne = false
            this.dodajDoValidatorMessages('Typ nie jest uzupełniony')
        }

        if (!Boolean(this.state.data)) {
            poprawne = false
            this.dodajDoValidatorMessages('Data nie jest uzupełniona')
        }

        if (poprawne) {
            this.setState({validatorMessages: []})


            this.props.handleClickZapisz(this.state.linia, Boolean(this.props.edytowana))
        }
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0}
                                                                                                                          wartosc={option.status}
                                                                                                                          czyMarginesLewy={true}/>
        </div>
    }

    render() {
        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.miejscowosc) ? 'Edycja linii' : 'Nowa linia'}</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} lg={1}>
                                <ControlLabel>
                                    Numer <span className={'req'}>*</span>
                                </ControlLabel>
                                <FormControl onChange={(e) => this.onChangeInput(e, 'numer')} id={'numerInput'}/>
                            </Col>
                            <Col xs={12} lg={3}>
                                <ControlLabel>Trasa główna <span className={'req'}>*</span></ControlLabel>
                                <TopSelect onChange={this.onChangeTrasaSelect}
                                           value={this.state.trasa}
                                           options={this.props.trasy}
                                           valueKey={'idTr'}
                                           labelKey={'nazTr'}
                                           valueRenderer={this.formatTrasaSelect}
                                           optionRenderer={this.formatTrasaSelect}
                                           placeholder={'Wybierz trasę...'}
                                           clearable={false}
                                />
                            </Col>
                            <Col xs={12} lg={3}>
                                <ControlLabel>Trasa powrotna <span className={'req'}>*</span></ControlLabel>
                                <TopSelect onChange={this.onChangeTrasaPowrotnaSelect}
                                           value={this.state.trasaPowrotna}
                                           options={this.props.trasy}
                                           valueKey={'idTr'}
                                           labelKey={'nazTr'}
                                           valueRenderer={this.formatTrasaSelect}
                                           optionRenderer={this.formatTrasaSelect}
                                           placeholder={'Wybierz trasę...'}
                                           clearable={false}
                                           disabled={!(Boolean(this.state.trasa))}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={3}>
                                <ControlLabel>
                                    Relacja <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.linia.relacja.length}/100 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={(e) => this.onChangeInput(e, 'relacja')} id={'relacjaInput'}/>
                            </Col>
                            <Col xs={12} lg={2}>
                                <ControlLabel>
                                    Typ <span className={'req'}>*</span>
                                </ControlLabel>
                                <TopSelectSlownik restUrl={AppConfig.HOST_API() + 'slownik/byNazwa/LINIA_TYP'}
                                                  onChange={this.onChangeTyp}
                                                  defaultValue={this.state.defaultTyp}
                                                  valueKey={'wartosc'}
                                                  labelKey={'wartosc'}
                                                  clearable={false}
                                />
                            </Col>
                            <Col xs={12} lg={3}>
                                <ControlLabel>
                                    Przedział [km] (jednorazowe) <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.linia.przedzialKm.length}/100 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={(e) => this.onChangeInput(e, 'przedzialKm')} id={'przedzialKmInput'}/>
                                <TopAlertInformacja text={'Należy podać cyfry całkowite oddzielone przecinkiem'}/>
                            </Col>
                            <Col xs={12} lg={3}>
                                <ControlLabel>
                                    Przedział [km] (miesięczne) <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.linia.przedzialKmMies !== undefined ? this.state.linia.przedzialKmMies.length : null}/100 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={(e) => this.onChangeInput(e, 'przedzialKmMies')} id={'przedzialKmMiesInput'}/>
                                <TopAlertInformacja text={'Należy podać cyfry całkowite oddzielone przecinkiem'}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={2}>
                                <ControlLabel>
                                    Data ważności <span className={'req'}>*</span>
                                </ControlLabel>
                                <TopInputDate onChange={this.onChangeData} value={this.state.data} horizontal={true}/>
                            </Col>
                            <Col xs={12} lg={2}>
                                <ControlLabel>
                                    Zezwolenie <span className={'req'}>*</span>
                                </ControlLabel>
                                <FormControl onChange={(e) => this.onChangeInput(e, 'zezwolenie')} id={'zezwolenieInput'}/> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.linia.zezwolenie.length}/30 znaków</span>
                            </Col>
                            <Col xs={12} lg={4}>
                                <ControlLabel>
                                    Wydawca <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.linia.wydawca.length}/100 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={(e) => this.onChangeInput(e, 'wydawca')} id={'wydawcaInput'}/>
                            </Col>


                            <Col xs={12} lg={3}>
                                <div className={'add-label-margin'}></div>
                                <TopButtonCancel onClick={() => {
                                    this.props.handleClickAnuluj()
                                }} text={'Anuluj'}/>
                                <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <ValidatorMessages messages={this.state.validatorMessages}/>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/linie/components/LinieForm.js